import React, { useEffect, useState } from "react";
import {
  onAuthStateChanged,
  signInWithEmailAndPassword,
  signOut,
} from "firebase/auth";
import { useNavigate } from "react-router-dom";
import { auth } from "../firebase";

const ADMIN_UID = "imXv7XiyoYSxJRg9kLzo7jhrbJI3";

function AdminLogin() {
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [submitting, setSubmitting] = useState(false);
  const [authReady, setAuthReady] = useState(false);

  useEffect(() => {
    const unsubscribe = onAuthStateChanged(auth, (user) => {
      setAuthReady(true);

      if (user?.uid === ADMIN_UID) {
        navigate("/admin-panel", { replace: true });
      }
    });

    return () => unsubscribe();
  }, [navigate]);

  const handleLogin = async (event) => {
    event.preventDefault();

    if (submitting) return;

    const cleanEmail = String(email || "").trim().toLowerCase();

    if (!cleanEmail) {
      return alert("Admin email enter karo.");
    }

    if (!password) {
      return alert("Admin password enter karo.");
    }

    setSubmitting(true);

    try {
      const credential = await signInWithEmailAndPassword(
        auth,
        cleanEmail,
        password
      );

      if (credential.user.uid !== ADMIN_UID) {
        await signOut(auth);
        return alert("Ye account Admin account nahi hai.");
      }

      navigate("/admin-panel", { replace: true });
    } catch (error) {
      console.error("Admin login error:", error);

      let message = error?.message || "Admin login failed.";

      if (error?.code === "auth/invalid-credential") {
        message = "Admin email ya password galat hai.";
      } else if (error?.code === "auth/too-many-requests") {
        message = "Bahut zyada login attempts hue hain. Thodi der baad try karo.";
      } else if (error?.code === "auth/network-request-failed") {
        message = "Internet connection check karo.";
      }

      alert(message);
    } finally {
      setSubmitting(false);
    }
  };

  if (!authReady) {
    return <div style={{ padding: 24 }}>Checking admin session...</div>;
  }

  return (
    <div
      style={{
        minHeight: "100vh",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        padding: 16,
        background: "#f5f7fb",
      }}
    >
      <form
        onSubmit={handleLogin}
        style={{
          width: "100%",
          maxWidth: 420,
          background: "#fff",
          borderRadius: 18,
          padding: 24,
          boxShadow: "0 12px 30px rgba(0,0,0,.10)",
        }}
      >
        <h2 style={{ marginTop: 0 }}>Admin Login</h2>
        <p style={{ color: "#64748b", marginTop: -6 }}>
          Firebase Admin account se sign in karein.
        </p>

        <label style={{ display: "block", fontWeight: 700, marginBottom: 7 }}>
          Admin Email
        </label>
        <input
          type="email"
          value={email}
          onChange={(event) => setEmail(event.target.value)}
          autoComplete="email"
          required
          style={inputStyle}
        />

        <label style={{ display: "block", fontWeight: 700, marginBottom: 7 }}>
          Admin Password
        </label>
        <input
          type="password"
          value={password}
          onChange={(event) => setPassword(event.target.value)}
          autoComplete="current-password"
          required
          style={inputStyle}
        />

        <button
          type="submit"
          disabled={submitting}
          style={{
            width: "100%",
            border: 0,
            borderRadius: 11,
            padding: 13,
            background: submitting ? "#94a3b8" : "#1d4ed8",
            color: "#fff",
            fontWeight: 800,
            cursor: submitting ? "not-allowed" : "pointer",
          }}
        >
          {submitting ? "Signing In..." : "Admin Login"}
        </button>
      </form>
    </div>
  );
}

const inputStyle = {
  width: "100%",
  padding: 12,
  marginBottom: 16,
  borderRadius: 11,
  border: "1px solid #cbd5e1",
  boxSizing: "border-box",
  fontSize: 15,
};

export default AdminLogin;
